export default (obj = {}, fn) => typeof fn === 'function'
  ? Object.keys(obj).reduce((o, k) => {
    const v = obj[k]
    o[fn(v, k)] = v
    return o
  }, {})
  : obj
